import React from 'react';
import Icon from '@mdi/react';
import { mdiPoll } from '@mdi/js';

const NoResultFound = ({
  height = '100%',
  title = 'Select more than one day to view the chart',
  icon = mdiPoll,
}) => {
  return (
    <div className='flex items-center justify-center  w-full' style={{ height: height }}>
      <div className='grid gap-2 text-color-xlight '>
        {icon && <Icon path={icon} size={2} className='m-auto' />}
        <span className='font-normal'>{title}</span>
      </div>
    </div>
  );
};

export default NoResultFound;
